import React, { SFC } from 'react'
import NavbarWrapper from '../Navbar'

interface Props {
  render?: () => React.ReactNode
}
export const PageWrapper: SFC<Props> = ({ children, render }) => {
  return <NavbarWrapper>{!!render ? render() : children}</NavbarWrapper>
}
